/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddEmployeeSchedulePatterns } from '../api-models';
// @ts-ignore
import { AssignedEmployeeRecord } from '../api-models';
// @ts-ignore
import { BaseResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfGetMasterViewRecordResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfAvailableEmployeesForOpeningTemplatesResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewMasterScheduleDraftDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfValidateEmployeeSchedulePatternDTO } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewMasterScheduleDraftDto } from '../api-models';
// @ts-ignore
import { CreateMasterScheduleDraftDto } from '../api-models';
// @ts-ignore
import { CreateMasterScheduleDraftElementDto } from '../api-models';
// @ts-ignore
import { GetMasterViewWithDraftElementResponse } from '../api-models';
// @ts-ignore
import { PublishDraftPatternResponse } from '../api-models';
// @ts-ignore
import { UpdateMasterScheduleDraftDto } from '../api-models';
// @ts-ignore
import { UpdateMasterScheduleDraftElementDto } from '../api-models';
// @ts-ignore
import { ViewMasterScheduleDraftDto } from '../api-models';
// @ts-ignore
import { ViewMasterScheduleDraftElementDto } from '../api-models';
/**
 * MasterScheduleApi - axios parameter creator
 * @export
 */
export const MasterScheduleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary After entering into draft mode, this API should be used to assign new employee  It will return the draftElementId if a draft is created. If Assiging an employee is actually undoing a previously  created draft element  then it will return zero instead of draft element Id.  In addition to draft element id, it also returns master schedule view data to re-render grid.
         * @param {AddEmployeeSchedulePatterns} [addEmployeeSchedulePatterns] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleAssignEmployeeDraftPost: async (addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MasterSchedule/assign-employee-draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEmployeeSchedulePatterns, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} openingTemplateId 
         * @param {number} [weekNumber] 
         * @param {number} [dayOfWeek] 
         * @param {string} [searchParam] 
         * @param {number} [masterScheduleDraftId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleAvailableEmployeesOpeningTemplateIdGet: async (openingTemplateId: number, weekNumber?: number, dayOfWeek?: number, searchParam?: string, masterScheduleDraftId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openingTemplateId' is not null or undefined
            assertParamExists('masterScheduleAvailableEmployeesOpeningTemplateIdGet', 'openingTemplateId', openingTemplateId)
            const localVarPath = `/MasterSchedule/AvailableEmployees/{openingTemplateId}`
                .replace(`{${"openingTemplateId"}}`, encodeURIComponent(String(openingTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (weekNumber !== undefined) {
                localVarQueryParameter['weekNumber'] = weekNumber;
            }

            if (dayOfWeek !== undefined) {
                localVarQueryParameter['dayOfWeek'] = dayOfWeek;
            }

            if (searchParam !== undefined) {
                localVarQueryParameter['searchParam'] = searchParam;
            }

            if (masterScheduleDraftId !== undefined) {
                localVarQueryParameter['masterScheduleDraftId'] = masterScheduleDraftId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleConfirmIdPatch: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleConfirmIdPatch', 'id', id)
            const localVarPath = `/MasterSchedule/confirm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleDiscardIdPatch: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleDiscardIdPatch', 'id', id)
            const localVarPath = `/MasterSchedule/discard/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleDraftIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleDraftIdGet', 'id', id)
            const localVarPath = `/MasterSchedule/draft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {number} [shiftTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleDraftsGet: async (facilityId?: number, departmentId?: number, positionId?: number, shiftTypeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MasterSchedule/drafts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MasterSchedule/element`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleElementIdDelete', 'id', id)
            const localVarPath = `/MasterSchedule/element/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleElementIdGet', 'id', id)
            const localVarPath = `/MasterSchedule/element/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMasterScheduleDraftElementDto} [updateMasterScheduleDraftElementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementIdPut: async (id: number, updateMasterScheduleDraftElementDto?: UpdateMasterScheduleDraftElementDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleElementIdPut', 'id', id)
            const localVarPath = `/MasterSchedule/element/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMasterScheduleDraftElementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new draft element for an existing draft
         * @param {CreateMasterScheduleDraftElementDto} [createMasterScheduleDraftElementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementPost: async (createMasterScheduleDraftElementDto?: CreateMasterScheduleDraftElementDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MasterSchedule/element`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMasterScheduleDraftElementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Used from master schedule view  Deprecated: Will be removed once master schedule draft is completed
         * @param {AddEmployeeSchedulePatterns} [addEmployeeSchedulePatterns] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        masterScheduleEmployeePatternDayPost: async (addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MasterSchedule/employee-pattern-day`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEmployeeSchedulePatterns, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MasterSchedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleIdDelete', 'id', id)
            const localVarPath = `/MasterSchedule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleIdGet', 'id', id)
            const localVarPath = `/MasterSchedule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleIdNamePatch: async (id: number, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleIdNamePatch', 'id', id)
            const localVarPath = `/MasterSchedule/{id}/name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMasterScheduleDraftDto} [updateMasterScheduleDraftDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleIdPut: async (id: number, updateMasterScheduleDraftDto?: UpdateMasterScheduleDraftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleIdPut', 'id', id)
            const localVarPath = `/MasterSchedule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMasterScheduleDraftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} weekNumber 
         * @param {number} [facilityId] 
         * @param {number} [shiftTypeId] 
         * @param {number} [positionId] 
         * @param {number} [masterScheduleDraftId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleMasterViewGet: async (departmentId: number, weekNumber: number, facilityId?: number, shiftTypeId?: number, positionId?: number, masterScheduleDraftId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('masterScheduleMasterViewGet', 'departmentId', departmentId)
            // verify required parameter 'weekNumber' is not null or undefined
            assertParamExists('masterScheduleMasterViewGet', 'weekNumber', weekNumber)
            const localVarPath = `/MasterSchedule/master-view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (weekNumber !== undefined) {
                localVarQueryParameter['weekNumber'] = weekNumber;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (masterScheduleDraftId !== undefined) {
                localVarQueryParameter['masterScheduleDraftId'] = masterScheduleDraftId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validation API used for single day on master schedule view  Deprecated: Will be removed once master schedule draft is completed
         * @param {number} employeeId 
         * @param {AddEmployeeSchedulePatterns} [addEmployeeSchedulePatterns] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        masterScheduleOverbudgetValidationEmployeeIdPost: async (employeeId: number, addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('masterScheduleOverbudgetValidationEmployeeIdPost', 'employeeId', employeeId)
            const localVarPath = `/MasterSchedule/overbudget-validation/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEmployeeSchedulePatterns, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Call this API before calling publish API for publishing drafts from master schedule planner.
         * @param {number} id 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleOverbudgetValidationIdGet: async (id: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterScheduleOverbudgetValidationIdGet', 'id', id)
            const localVarPath = `/MasterSchedule/overbudget-validation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enters into draft mode by creating a draft
         * @param {CreateMasterScheduleDraftDto} [createMasterScheduleDraftDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSchedulePost: async (createMasterScheduleDraftDto?: CreateMasterScheduleDraftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MasterSchedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMasterScheduleDraftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSchedulePublishIdPatch: async (id: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('masterSchedulePublishIdPatch', 'id', id)
            const localVarPath = `/MasterSchedule/publish/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary After entering into draft mode, this API should be used to remove employee  It will return the draftElementId if a draft is created. If remove an employee is actually undoing a previously  created draft element  then it will return zero instead of draft element Id.  In addition to draft element id, it also returns master schedule view data to re-render grid.
         * @param {AssignedEmployeeRecord} [assignedEmployeeRecord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleRemoveEmployeeDraftDelete: async (assignedEmployeeRecord?: AssignedEmployeeRecord, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MasterSchedule/remove-employee-draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignedEmployeeRecord, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterScheduleApi - functional programming interface
 * @export
 */
export const MasterScheduleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterScheduleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary After entering into draft mode, this API should be used to assign new employee  It will return the draftElementId if a draft is created. If Assiging an employee is actually undoing a previously  created draft element  then it will return zero instead of draft element Id.  In addition to draft element id, it also returns master schedule view data to re-render grid.
         * @param {AddEmployeeSchedulePatterns} [addEmployeeSchedulePatterns] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleAssignEmployeeDraftPost(addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMasterViewWithDraftElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleAssignEmployeeDraftPost(addEmployeeSchedulePatterns, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} openingTemplateId 
         * @param {number} [weekNumber] 
         * @param {number} [dayOfWeek] 
         * @param {string} [searchParam] 
         * @param {number} [masterScheduleDraftId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleAvailableEmployeesOpeningTemplateIdGet(openingTemplateId: number, weekNumber?: number, dayOfWeek?: number, searchParam?: string, masterScheduleDraftId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfAvailableEmployeesForOpeningTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleAvailableEmployeesOpeningTemplateIdGet(openingTemplateId, weekNumber, dayOfWeek, searchParam, masterScheduleDraftId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleConfirmIdPatch(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleConfirmIdPatch(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleDiscardIdPatch(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleDiscardIdPatch(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleDraftIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewMasterScheduleDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleDraftIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {number} [shiftTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleDraftsGet(facilityId?: number, departmentId?: number, positionId?: number, shiftTypeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewMasterScheduleDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleDraftsGet(facilityId, departmentId, positionId, shiftTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleElementGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewMasterScheduleDraftElementDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleElementGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleElementIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewMasterScheduleDraftElementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleElementIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleElementIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewMasterScheduleDraftElementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleElementIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMasterScheduleDraftElementDto} [updateMasterScheduleDraftElementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleElementIdPut(id: number, updateMasterScheduleDraftElementDto?: UpdateMasterScheduleDraftElementDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewMasterScheduleDraftElementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleElementIdPut(id, updateMasterScheduleDraftElementDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates new draft element for an existing draft
         * @param {CreateMasterScheduleDraftElementDto} [createMasterScheduleDraftElementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleElementPost(createMasterScheduleDraftElementDto?: CreateMasterScheduleDraftElementDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewMasterScheduleDraftElementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleElementPost(createMasterScheduleDraftElementDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Used from master schedule view  Deprecated: Will be removed once master schedule draft is completed
         * @param {AddEmployeeSchedulePatterns} [addEmployeeSchedulePatterns] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async masterScheduleEmployeePatternDayPost(addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleEmployeePatternDayPost(addEmployeeSchedulePatterns, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewMasterScheduleDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewMasterScheduleDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleIdNamePatch(id: number, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleIdNamePatch(id, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMasterScheduleDraftDto} [updateMasterScheduleDraftDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleIdPut(id: number, updateMasterScheduleDraftDto?: UpdateMasterScheduleDraftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewMasterScheduleDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleIdPut(id, updateMasterScheduleDraftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} weekNumber 
         * @param {number} [facilityId] 
         * @param {number} [shiftTypeId] 
         * @param {number} [positionId] 
         * @param {number} [masterScheduleDraftId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleMasterViewGet(departmentId: number, weekNumber: number, facilityId?: number, shiftTypeId?: number, positionId?: number, masterScheduleDraftId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfGetMasterViewRecordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleMasterViewGet(departmentId, weekNumber, facilityId, shiftTypeId, positionId, masterScheduleDraftId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validation API used for single day on master schedule view  Deprecated: Will be removed once master schedule draft is completed
         * @param {number} employeeId 
         * @param {AddEmployeeSchedulePatterns} [addEmployeeSchedulePatterns] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async masterScheduleOverbudgetValidationEmployeeIdPost(employeeId: number, addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfValidateEmployeeSchedulePatternDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleOverbudgetValidationEmployeeIdPost(employeeId, addEmployeeSchedulePatterns, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Call this API before calling publish API for publishing drafts from master schedule planner.
         * @param {number} id 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleOverbudgetValidationIdGet(id: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishDraftPatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleOverbudgetValidationIdGet(id, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enters into draft mode by creating a draft
         * @param {CreateMasterScheduleDraftDto} [createMasterScheduleDraftDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterSchedulePost(createMasterScheduleDraftDto?: CreateMasterScheduleDraftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewMasterScheduleDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterSchedulePost(createMasterScheduleDraftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterSchedulePublishIdPatch(id: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishDraftPatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterSchedulePublishIdPatch(id, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary After entering into draft mode, this API should be used to remove employee  It will return the draftElementId if a draft is created. If remove an employee is actually undoing a previously  created draft element  then it will return zero instead of draft element Id.  In addition to draft element id, it also returns master schedule view data to re-render grid.
         * @param {AssignedEmployeeRecord} [assignedEmployeeRecord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterScheduleRemoveEmployeeDraftDelete(assignedEmployeeRecord?: AssignedEmployeeRecord, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMasterViewWithDraftElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterScheduleRemoveEmployeeDraftDelete(assignedEmployeeRecord, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterScheduleApi - factory interface
 * @export
 */
export const MasterScheduleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterScheduleApiFp(configuration)
    return {
        /**
         * 
         * @summary After entering into draft mode, this API should be used to assign new employee  It will return the draftElementId if a draft is created. If Assiging an employee is actually undoing a previously  created draft element  then it will return zero instead of draft element Id.  In addition to draft element id, it also returns master schedule view data to re-render grid.
         * @param {MasterScheduleApiMasterScheduleAssignEmployeeDraftPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleAssignEmployeeDraftPost(requestParameters: MasterScheduleApiMasterScheduleAssignEmployeeDraftPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetMasterViewWithDraftElementResponse> {
            return localVarFp.masterScheduleAssignEmployeeDraftPost(requestParameters.addEmployeeSchedulePatterns, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleAvailableEmployeesOpeningTemplateIdGet(requestParameters: MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfAvailableEmployeesForOpeningTemplatesResponse> {
            return localVarFp.masterScheduleAvailableEmployeesOpeningTemplateIdGet(requestParameters.openingTemplateId, requestParameters.weekNumber, requestParameters.dayOfWeek, requestParameters.searchParam, requestParameters.masterScheduleDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleConfirmIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleConfirmIdPatch(requestParameters: MasterScheduleApiMasterScheduleConfirmIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.masterScheduleConfirmIdPatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleDiscardIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleDiscardIdPatch(requestParameters: MasterScheduleApiMasterScheduleDiscardIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.masterScheduleDiscardIdPatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleDraftIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleDraftIdGet(requestParameters: MasterScheduleApiMasterScheduleDraftIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ViewMasterScheduleDraftDto> {
            return localVarFp.masterScheduleDraftIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleDraftsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleDraftsGet(requestParameters: MasterScheduleApiMasterScheduleDraftsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ViewMasterScheduleDraftDto> {
            return localVarFp.masterScheduleDraftsGet(requestParameters.facilityId, requestParameters.departmentId, requestParameters.positionId, requestParameters.shiftTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementGet(options?: AxiosRequestConfig): AxiosPromise<Array<ViewMasterScheduleDraftElementDto>> {
            return localVarFp.masterScheduleElementGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleElementIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementIdDelete(requestParameters: MasterScheduleApiMasterScheduleElementIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<ViewMasterScheduleDraftElementDto> {
            return localVarFp.masterScheduleElementIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleElementIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementIdGet(requestParameters: MasterScheduleApiMasterScheduleElementIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ViewMasterScheduleDraftElementDto> {
            return localVarFp.masterScheduleElementIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleElementIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementIdPut(requestParameters: MasterScheduleApiMasterScheduleElementIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<ViewMasterScheduleDraftElementDto> {
            return localVarFp.masterScheduleElementIdPut(requestParameters.id, requestParameters.updateMasterScheduleDraftElementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new draft element for an existing draft
         * @param {MasterScheduleApiMasterScheduleElementPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleElementPost(requestParameters: MasterScheduleApiMasterScheduleElementPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ViewMasterScheduleDraftElementDto> {
            return localVarFp.masterScheduleElementPost(requestParameters.createMasterScheduleDraftElementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Used from master schedule view  Deprecated: Will be removed once master schedule draft is completed
         * @param {MasterScheduleApiMasterScheduleEmployeePatternDayPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        masterScheduleEmployeePatternDayPost(requestParameters: MasterScheduleApiMasterScheduleEmployeePatternDayPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.masterScheduleEmployeePatternDayPost(requestParameters.addEmployeeSchedulePatterns, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleGet(options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewMasterScheduleDraftDto> {
            return localVarFp.masterScheduleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleIdDelete(requestParameters: MasterScheduleApiMasterScheduleIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.masterScheduleIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleIdGet(requestParameters: MasterScheduleApiMasterScheduleIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewMasterScheduleDraftDto> {
            return localVarFp.masterScheduleIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleIdNamePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleIdNamePatch(requestParameters: MasterScheduleApiMasterScheduleIdNamePatchRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.masterScheduleIdNamePatch(requestParameters.id, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleIdPut(requestParameters: MasterScheduleApiMasterScheduleIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewMasterScheduleDraftDto> {
            return localVarFp.masterScheduleIdPut(requestParameters.id, requestParameters.updateMasterScheduleDraftDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterScheduleMasterViewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleMasterViewGet(requestParameters: MasterScheduleApiMasterScheduleMasterViewGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfGetMasterViewRecordResponse> {
            return localVarFp.masterScheduleMasterViewGet(requestParameters.departmentId, requestParameters.weekNumber, requestParameters.facilityId, requestParameters.shiftTypeId, requestParameters.positionId, requestParameters.masterScheduleDraftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validation API used for single day on master schedule view  Deprecated: Will be removed once master schedule draft is completed
         * @param {MasterScheduleApiMasterScheduleOverbudgetValidationEmployeeIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        masterScheduleOverbudgetValidationEmployeeIdPost(requestParameters: MasterScheduleApiMasterScheduleOverbudgetValidationEmployeeIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfValidateEmployeeSchedulePatternDTO> {
            return localVarFp.masterScheduleOverbudgetValidationEmployeeIdPost(requestParameters.employeeId, requestParameters.addEmployeeSchedulePatterns, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Call this API before calling publish API for publishing drafts from master schedule planner.
         * @param {MasterScheduleApiMasterScheduleOverbudgetValidationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleOverbudgetValidationIdGet(requestParameters: MasterScheduleApiMasterScheduleOverbudgetValidationIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<PublishDraftPatternResponse> {
            return localVarFp.masterScheduleOverbudgetValidationIdGet(requestParameters.id, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enters into draft mode by creating a draft
         * @param {MasterScheduleApiMasterSchedulePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSchedulePost(requestParameters: MasterScheduleApiMasterSchedulePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewMasterScheduleDraftDto> {
            return localVarFp.masterSchedulePost(requestParameters.createMasterScheduleDraftDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MasterScheduleApiMasterSchedulePublishIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSchedulePublishIdPatch(requestParameters: MasterScheduleApiMasterSchedulePublishIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<PublishDraftPatternResponse> {
            return localVarFp.masterSchedulePublishIdPatch(requestParameters.id, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary After entering into draft mode, this API should be used to remove employee  It will return the draftElementId if a draft is created. If remove an employee is actually undoing a previously  created draft element  then it will return zero instead of draft element Id.  In addition to draft element id, it also returns master schedule view data to re-render grid.
         * @param {MasterScheduleApiMasterScheduleRemoveEmployeeDraftDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterScheduleRemoveEmployeeDraftDelete(requestParameters: MasterScheduleApiMasterScheduleRemoveEmployeeDraftDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetMasterViewWithDraftElementResponse> {
            return localVarFp.masterScheduleRemoveEmployeeDraftDelete(requestParameters.assignedEmployeeRecord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for masterScheduleAssignEmployeeDraftPost operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleAssignEmployeeDraftPostRequest
 */
export interface MasterScheduleApiMasterScheduleAssignEmployeeDraftPostRequest {
    /**
     * 
     * @type {AddEmployeeSchedulePatterns}
     * @memberof MasterScheduleApiMasterScheduleAssignEmployeeDraftPost
     */
    readonly addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns
}

/**
 * Request parameters for masterScheduleAvailableEmployeesOpeningTemplateIdGet operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGetRequest
 */
export interface MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGet
     */
    readonly openingTemplateId: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGet
     */
    readonly weekNumber?: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGet
     */
    readonly dayOfWeek?: number

    /**
     * 
     * @type {string}
     * @memberof MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGet
     */
    readonly searchParam?: string

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGet
     */
    readonly masterScheduleDraftId?: number
}

/**
 * Request parameters for masterScheduleConfirmIdPatch operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleConfirmIdPatchRequest
 */
export interface MasterScheduleApiMasterScheduleConfirmIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleConfirmIdPatch
     */
    readonly id: number
}

/**
 * Request parameters for masterScheduleDiscardIdPatch operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleDiscardIdPatchRequest
 */
export interface MasterScheduleApiMasterScheduleDiscardIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleDiscardIdPatch
     */
    readonly id: number
}

/**
 * Request parameters for masterScheduleDraftIdGet operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleDraftIdGetRequest
 */
export interface MasterScheduleApiMasterScheduleDraftIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleDraftIdGet
     */
    readonly id: number
}

/**
 * Request parameters for masterScheduleDraftsGet operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleDraftsGetRequest
 */
export interface MasterScheduleApiMasterScheduleDraftsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleDraftsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleDraftsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleDraftsGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleDraftsGet
     */
    readonly shiftTypeId?: number
}

/**
 * Request parameters for masterScheduleElementIdDelete operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleElementIdDeleteRequest
 */
export interface MasterScheduleApiMasterScheduleElementIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleElementIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for masterScheduleElementIdGet operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleElementIdGetRequest
 */
export interface MasterScheduleApiMasterScheduleElementIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleElementIdGet
     */
    readonly id: number
}

/**
 * Request parameters for masterScheduleElementIdPut operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleElementIdPutRequest
 */
export interface MasterScheduleApiMasterScheduleElementIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleElementIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateMasterScheduleDraftElementDto}
     * @memberof MasterScheduleApiMasterScheduleElementIdPut
     */
    readonly updateMasterScheduleDraftElementDto?: UpdateMasterScheduleDraftElementDto
}

/**
 * Request parameters for masterScheduleElementPost operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleElementPostRequest
 */
export interface MasterScheduleApiMasterScheduleElementPostRequest {
    /**
     * 
     * @type {CreateMasterScheduleDraftElementDto}
     * @memberof MasterScheduleApiMasterScheduleElementPost
     */
    readonly createMasterScheduleDraftElementDto?: CreateMasterScheduleDraftElementDto
}

/**
 * Request parameters for masterScheduleEmployeePatternDayPost operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleEmployeePatternDayPostRequest
 */
export interface MasterScheduleApiMasterScheduleEmployeePatternDayPostRequest {
    /**
     * 
     * @type {AddEmployeeSchedulePatterns}
     * @memberof MasterScheduleApiMasterScheduleEmployeePatternDayPost
     */
    readonly addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns
}

/**
 * Request parameters for masterScheduleIdDelete operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleIdDeleteRequest
 */
export interface MasterScheduleApiMasterScheduleIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for masterScheduleIdGet operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleIdGetRequest
 */
export interface MasterScheduleApiMasterScheduleIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleIdGet
     */
    readonly id: number
}

/**
 * Request parameters for masterScheduleIdNamePatch operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleIdNamePatchRequest
 */
export interface MasterScheduleApiMasterScheduleIdNamePatchRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleIdNamePatch
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof MasterScheduleApiMasterScheduleIdNamePatch
     */
    readonly name?: string
}

/**
 * Request parameters for masterScheduleIdPut operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleIdPutRequest
 */
export interface MasterScheduleApiMasterScheduleIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateMasterScheduleDraftDto}
     * @memberof MasterScheduleApiMasterScheduleIdPut
     */
    readonly updateMasterScheduleDraftDto?: UpdateMasterScheduleDraftDto
}

/**
 * Request parameters for masterScheduleMasterViewGet operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleMasterViewGetRequest
 */
export interface MasterScheduleApiMasterScheduleMasterViewGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleMasterViewGet
     */
    readonly departmentId: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleMasterViewGet
     */
    readonly weekNumber: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleMasterViewGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleMasterViewGet
     */
    readonly shiftTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleMasterViewGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleMasterViewGet
     */
    readonly masterScheduleDraftId?: number
}

/**
 * Request parameters for masterScheduleOverbudgetValidationEmployeeIdPost operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleOverbudgetValidationEmployeeIdPostRequest
 */
export interface MasterScheduleApiMasterScheduleOverbudgetValidationEmployeeIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleOverbudgetValidationEmployeeIdPost
     */
    readonly employeeId: number

    /**
     * 
     * @type {AddEmployeeSchedulePatterns}
     * @memberof MasterScheduleApiMasterScheduleOverbudgetValidationEmployeeIdPost
     */
    readonly addEmployeeSchedulePatterns?: AddEmployeeSchedulePatterns
}

/**
 * Request parameters for masterScheduleOverbudgetValidationIdGet operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleOverbudgetValidationIdGetRequest
 */
export interface MasterScheduleApiMasterScheduleOverbudgetValidationIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleOverbudgetValidationIdGet
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterScheduleOverbudgetValidationIdGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for masterSchedulePost operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterSchedulePostRequest
 */
export interface MasterScheduleApiMasterSchedulePostRequest {
    /**
     * 
     * @type {CreateMasterScheduleDraftDto}
     * @memberof MasterScheduleApiMasterSchedulePost
     */
    readonly createMasterScheduleDraftDto?: CreateMasterScheduleDraftDto
}

/**
 * Request parameters for masterSchedulePublishIdPatch operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterSchedulePublishIdPatchRequest
 */
export interface MasterScheduleApiMasterSchedulePublishIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterSchedulePublishIdPatch
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof MasterScheduleApiMasterSchedulePublishIdPatch
     */
    readonly facilityId?: number
}

/**
 * Request parameters for masterScheduleRemoveEmployeeDraftDelete operation in MasterScheduleApi.
 * @export
 * @interface MasterScheduleApiMasterScheduleRemoveEmployeeDraftDeleteRequest
 */
export interface MasterScheduleApiMasterScheduleRemoveEmployeeDraftDeleteRequest {
    /**
     * 
     * @type {AssignedEmployeeRecord}
     * @memberof MasterScheduleApiMasterScheduleRemoveEmployeeDraftDelete
     */
    readonly assignedEmployeeRecord?: AssignedEmployeeRecord
}

/**
 * MasterScheduleApi - object-oriented interface
 * @export
 * @class MasterScheduleApi
 * @extends {BaseAPI}
 */
export class MasterScheduleApi extends BaseAPI {
    /**
     * 
     * @summary After entering into draft mode, this API should be used to assign new employee  It will return the draftElementId if a draft is created. If Assiging an employee is actually undoing a previously  created draft element  then it will return zero instead of draft element Id.  In addition to draft element id, it also returns master schedule view data to re-render grid.
     * @param {MasterScheduleApiMasterScheduleAssignEmployeeDraftPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleAssignEmployeeDraftPost(requestParameters: MasterScheduleApiMasterScheduleAssignEmployeeDraftPostRequest = {}, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleAssignEmployeeDraftPost(requestParameters.addEmployeeSchedulePatterns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleAvailableEmployeesOpeningTemplateIdGet(requestParameters: MasterScheduleApiMasterScheduleAvailableEmployeesOpeningTemplateIdGetRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleAvailableEmployeesOpeningTemplateIdGet(requestParameters.openingTemplateId, requestParameters.weekNumber, requestParameters.dayOfWeek, requestParameters.searchParam, requestParameters.masterScheduleDraftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleConfirmIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleConfirmIdPatch(requestParameters: MasterScheduleApiMasterScheduleConfirmIdPatchRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleConfirmIdPatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleDiscardIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleDiscardIdPatch(requestParameters: MasterScheduleApiMasterScheduleDiscardIdPatchRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleDiscardIdPatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleDraftIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleDraftIdGet(requestParameters: MasterScheduleApiMasterScheduleDraftIdGetRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleDraftIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleDraftsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleDraftsGet(requestParameters: MasterScheduleApiMasterScheduleDraftsGetRequest = {}, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleDraftsGet(requestParameters.facilityId, requestParameters.departmentId, requestParameters.positionId, requestParameters.shiftTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleElementGet(options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleElementGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleElementIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleElementIdDelete(requestParameters: MasterScheduleApiMasterScheduleElementIdDeleteRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleElementIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleElementIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleElementIdGet(requestParameters: MasterScheduleApiMasterScheduleElementIdGetRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleElementIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleElementIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleElementIdPut(requestParameters: MasterScheduleApiMasterScheduleElementIdPutRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleElementIdPut(requestParameters.id, requestParameters.updateMasterScheduleDraftElementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new draft element for an existing draft
     * @param {MasterScheduleApiMasterScheduleElementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleElementPost(requestParameters: MasterScheduleApiMasterScheduleElementPostRequest = {}, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleElementPost(requestParameters.createMasterScheduleDraftElementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Used from master schedule view  Deprecated: Will be removed once master schedule draft is completed
     * @param {MasterScheduleApiMasterScheduleEmployeePatternDayPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleEmployeePatternDayPost(requestParameters: MasterScheduleApiMasterScheduleEmployeePatternDayPostRequest = {}, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleEmployeePatternDayPost(requestParameters.addEmployeeSchedulePatterns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleGet(options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleIdDelete(requestParameters: MasterScheduleApiMasterScheduleIdDeleteRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleIdGet(requestParameters: MasterScheduleApiMasterScheduleIdGetRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleIdNamePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleIdNamePatch(requestParameters: MasterScheduleApiMasterScheduleIdNamePatchRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleIdNamePatch(requestParameters.id, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleIdPut(requestParameters: MasterScheduleApiMasterScheduleIdPutRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleIdPut(requestParameters.id, requestParameters.updateMasterScheduleDraftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterScheduleMasterViewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleMasterViewGet(requestParameters: MasterScheduleApiMasterScheduleMasterViewGetRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleMasterViewGet(requestParameters.departmentId, requestParameters.weekNumber, requestParameters.facilityId, requestParameters.shiftTypeId, requestParameters.positionId, requestParameters.masterScheduleDraftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validation API used for single day on master schedule view  Deprecated: Will be removed once master schedule draft is completed
     * @param {MasterScheduleApiMasterScheduleOverbudgetValidationEmployeeIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleOverbudgetValidationEmployeeIdPost(requestParameters: MasterScheduleApiMasterScheduleOverbudgetValidationEmployeeIdPostRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleOverbudgetValidationEmployeeIdPost(requestParameters.employeeId, requestParameters.addEmployeeSchedulePatterns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Call this API before calling publish API for publishing drafts from master schedule planner.
     * @param {MasterScheduleApiMasterScheduleOverbudgetValidationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleOverbudgetValidationIdGet(requestParameters: MasterScheduleApiMasterScheduleOverbudgetValidationIdGetRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleOverbudgetValidationIdGet(requestParameters.id, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enters into draft mode by creating a draft
     * @param {MasterScheduleApiMasterSchedulePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterSchedulePost(requestParameters: MasterScheduleApiMasterSchedulePostRequest = {}, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterSchedulePost(requestParameters.createMasterScheduleDraftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MasterScheduleApiMasterSchedulePublishIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterSchedulePublishIdPatch(requestParameters: MasterScheduleApiMasterSchedulePublishIdPatchRequest, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterSchedulePublishIdPatch(requestParameters.id, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary After entering into draft mode, this API should be used to remove employee  It will return the draftElementId if a draft is created. If remove an employee is actually undoing a previously  created draft element  then it will return zero instead of draft element Id.  In addition to draft element id, it also returns master schedule view data to re-render grid.
     * @param {MasterScheduleApiMasterScheduleRemoveEmployeeDraftDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterScheduleApi
     */
    public masterScheduleRemoveEmployeeDraftDelete(requestParameters: MasterScheduleApiMasterScheduleRemoveEmployeeDraftDeleteRequest = {}, options?: AxiosRequestConfig) {
        return MasterScheduleApiFp(this.configuration).masterScheduleRemoveEmployeeDraftDelete(requestParameters.assignedEmployeeRecord, options).then((request) => request(this.axios, this.basePath));
    }
}
